import styled from 'particles/themes/styled'

export const SaveContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 100%;
    overflow-y: auto;
    background-color: ${({ theme }) => theme.colors.background.secondary};
    form {
        height: 100%;
        position: relative;
    }
    .form-field {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[600]};
        padding: 18px 18px 0;
        min-height: calc(100% - 60px);
        box-sizing: border-box;
        -webkit-overflow-scrolling: touch;
        @media screen and (max-width: 768px) {
            padding: 12px 12px 150px;
            overflow-x: hidden;
        }
    }

    .button-group {
        width: 100%;
        position: sticky;
        bottom: 0;
        background-color: ${({ theme }) => theme.colors.background.secondary};
        box-shadow: 2px 0px 8px rgba(0, 0, 0, 0.06);
        padding: 14px 24px;
        display: flex;
        justify-content: flex-end;
        box-sizing: border-box;
        gap: ${({ theme }) => theme.spacing[600]};
        z-index: 200;
        @media screen and (max-width: 768px) {
            width: calc(100% - 16px);
            left: 50%;
            bottom: 0;
            position: fixed;
            transform: translateX(-50%);
        }
    }
    .divider {
        margin: 24px 0;
    }
`
export const EditorContainer = styled.div`
    display: flex;
    flex-direction: column;

    .first-divider {
        margin: 16px 0 24px;
    }
    .form-title {
        margin-bottom: 32px;
    }
    .editor-form-field {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[600]};
    }
`
